export const OPTION_TYPE = {
    STRING: "string",
    INT: "int",
    BOOL: "bool",
    DATETIME: "datetime",
    DICTIONARY: "dict",
    TAGS: "tags",
    IMAGE: "image",
    GEOSPATIAL: "geospatial",
    DECIMAL: "decimal"
};
